import { getDescendantCodes } from "@l2r-front/l2r-utils"

import { useHorizontalSignTypes } from "../queries/horizontalSigning/useHorizontalSignTypes"

export function useHorizontalSignDescendantCodes(code) {
    const { data: horizontalSignTypes } = useHorizontalSignTypes()

    return getDescendantCodes(code, horizontalSignTypes)
}